var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wkb-expand-intent" }, [
    _vm._m(0),
    _c("p", { staticClass: "wkb-expand-intent-note" }, [
      _vm._v(
        " Genes are not added from free text — use Expand or the inspector on added nodes to place gene nodes (up to " +
          _vm._s(_vm.expandMaxNeighbors) +
          " per expand step). "
      ),
    ]),
    _c("p", { staticClass: "wkb-expand-intent-workflow" }, [
      _vm._v(
        " Need many genes, gene sets, or traits at once for a research question? "
      ),
      _c(
        "a",
        {
          staticClass: "wkb-expand-intent-workflow-link",
          attrs: {
            href: _vm.workflowUrl,
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
        [_vm._v("Open " + _vm._s(_vm.workflowTitle))]
      ),
      _vm._v(" for bulk discovery. "),
    ]),
    _c("label", { staticClass: "wkb-expand-intent-field" }, [
      _c("span", { staticClass: "wkb-expand-intent-label" }, [
        _vm._v("Research intention"),
      ]),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.intention,
            expression: "intention",
          },
        ],
        staticClass: "wkb-expand-intent-textarea",
        attrs: {
          rows: "3",
          disabled: _vm.busy || !_vm.llmAvailable,
          placeholder:
            "Example: Find a glycosylation mechanism that could alter lipoprotein handling and coagulation",
        },
        domProps: { value: _vm.intention },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.intention = $event.target.value
          },
        },
      }),
    ]),
    !_vm.llmAvailable
      ? _c("p", { staticClass: "wkb-expand-intent-status" }, [
          _vm._v(" Intention-based add requires an LLM backend. "),
        ])
      : _vm.statusMessage
      ? _c(
          "p",
          {
            staticClass: "wkb-expand-intent-status",
            attrs: { role: "status" },
          },
          [_vm._v(" " + _vm._s(_vm.statusMessage) + " ")]
        )
      : _vm._e(),
    _c(
      "button",
      {
        staticClass: "wkb-expand-intent-submit",
        attrs: {
          type: "button",
          disabled: _vm.busy || !_vm.llmAvailable || !_vm.intention.trim(),
        },
        on: { click: _vm.runIntentAdd },
      },
      [
        _vm._v(
          " " + _vm._s(_vm.busy ? "Finding nodes…" : "Find & add nodes") + " "
        ),
      ]
    ),
    _vm.lastExplanation
      ? _c("p", { staticClass: "wkb-expand-intent-explanation" }, [
          _vm._v(" " + _vm._s(_vm.lastExplanation) + " "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-expand-intent-intro" }, [
      _vm._v(
        " Describe your research goal in plain language. We will plan catalog searches for "
      ),
      _c("strong", [_vm._v("gene sets")]),
      _vm._v(", "),
      _c("strong", [_vm._v("mechanisms")]),
      _vm._v(", and "),
      _c("strong", [_vm._v("traits")]),
      _vm._v(", then add the best matches to the graph. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }